export default __webpack_public_path__ + "static/media/following.ef065fbd.svg";